import styled from 'styled-components';
import Icon from '../../components/Icon'
import Button from '../../components/inputs/Button';

export const StyledSearch = styled.div`
    position: relative;
`

export const StyledSearchInput = styled.div`
    display: flex;
    align-items: center;
`

export const StyledButtonClose = styled(Button)`
    font-size: 16px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.greyishBrown};
    cursor: pointer;
    align-self: flex-end;
    height: 52px;
    min-width: 85px;
`

export const StyledSearchResults = styled.div`
    position: static;
    padding: 0 10px;
    width: 100%;
    overflow: hidden;
    background: ${({ theme }) => theme.white};
    z-index: 3;
};
`

export const StyledSearchResultsTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.brownGrey};
    margin: 10px 0;
`

export const StyledSearchResultsList = styled.div`
    width: 100%;
    overflow-y: auto;
    height: 100%;
    flex: 1;
`

export const StyledSearchHint = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    height: 28px;
`

export const StyledSearchHintIcon = styled(Icon).attrs(({ theme }) => ({
    color: theme.grassyGreen,
}))`
    margin-right: 5px;
`


export const StyledSearchHintText = styled.span`
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.grassyGreen};
    font-size: 12px;
`